import type { WrapperProps } from '~/types'

export const Wrapper = ({ children, className = '' }: WrapperProps) => (
  <div className={`${className.length ? className : 'container mx-auto'}`}>{children}</div>
)
